import * as React from 'react';

export interface CorporationIconProps {
  className?: string;
  size?: number;
  title?: string;
}

/**
 * CorporationIcon — PCB Retail Modal entity icon (v2.5)
 *
 * @description C-Corp / S-Corp entity. Industrial/commercial building silhouette with smokestacks.
 */
const CorporationIcon: React.FunctionComponent<CorporationIconProps> = ({
  className,
  size = 40,
  title = 'Corporation',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={size}
    height={size}
    className={className}
    role="img"
    aria-label={title}
  >
    <title>{title}</title>
      <rect x="20" y="2" width="4" height="12" fill="#1f4f84"/>
      <rect x="19" y="6" width="6" height="2" fill="#3a6fa3"/>
      <rect x="26" y="6" width="4" height="8" fill="#1f4f84"/>
      <rect x="25" y="9" width="6" height="2" fill="#3a6fa3"/>
      <rect x="6" y="20" width="8" height="22" fill="#2968ad"/>
      <rect x="8" y="24" width="1.5" height="3" fill="#FFFFFF"/>
      <rect x="11" y="24" width="1.5" height="3" fill="#FFFFFF"/>
      <rect x="8" y="29" width="1.5" height="3" fill="#FFFFFF"/>
      <rect x="11" y="29" width="1.5" height="3" fill="#FFFFFF"/>
      <rect x="8" y="34" width="1.5" height="3" fill="#FFFFFF"/>
      <rect x="11" y="34" width="1.5" height="3" fill="#FFFFFF"/>
      <path d="M14 14 L34 14 L42 18 L42 42 L14 42 Z" fill="#2968ad"/>
      <path d="M14 14 L34 14 L42 18 L42 22 L14 22 Z" fill="#3a6fa3"/>
      <rect x="18" y="26" width="3" height="3" fill="#FFFFFF"/>
      <rect x="23" y="26" width="3" height="3" fill="#FFFFFF"/>
      <rect x="28" y="26" width="3" height="3" fill="#FFFFFF"/>
      <rect x="34" y="26" width="3" height="3" fill="#FFFFFF"/>
      <rect x="38" y="26" width="3" height="3" fill="#FFFFFF"/>
      <rect x="18" y="31" width="3" height="3" fill="#FFFFFF"/>
      <rect x="34" y="31" width="3" height="3" fill="#FFFFFF"/>
      <rect x="38" y="31" width="3" height="3" fill="#FFFFFF"/>
      <path d="M23 42 L23 36 Q23 32 28 32 Q33 32 33 36 L33 42 Z" fill="#FFFFFF"/>
      <line x1="28" y1="32" x2="28" y2="42" stroke="#2968ad" strokeWidth="0.6"/>
      <rect x="4" y="42" width="40" height="1.5" fill="#1f4f84"/>
  </svg>
);

export default CorporationIcon;
